import { render, staticRenderFns } from "./fixAddGoods.vue?vue&type=template&id=4684cdac&scoped=true&"
import script from "./fixAddGoods.vue?vue&type=script&lang=js&"
export * from "./fixAddGoods.vue?vue&type=script&lang=js&"
import style0 from "./fixAddGoods.vue?vue&type=style&index=0&id=4684cdac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684cdac",
  null
  
)

export default component.exports